import React from 'react';

var Nfc = function Nfc(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.72 15.016a.823.823 0 0 1-1.143.302.869.869 0 0 1-.294-1.173 3.519 3.519 0 0 0 .477-1.772c0-.723-.216-1.422-.613-2.012a.87.87 0 0 1 .214-1.19c.38-.27.9-.171 1.161.218a5.35 5.35 0 0 1 .907 2.984c0 .94-.246 1.837-.709 2.643zm2.711 1.583a.823.823 0 0 1-1.149.278.87.87 0 0 1-.271-1.178c.564-.937.877-2.093.877-3.326 0-1.345-.373-2.615-1.025-3.578a.87.87 0 0 1 .21-1.192.822.822 0 0 1 1.162.216c.849 1.255 1.323 2.866 1.323 4.554 0 1.547-.398 3.016-1.127 4.226zm2.33 1.685a.82.82 0 0 1-1.176.096.872.872 0 0 1-.093-1.207c.95-1.143 1.526-2.893 1.526-4.8 0-2.048-.665-3.917-1.728-5.037a.872.872 0 0 1 .016-1.211.82.82 0 0 1 1.18.016c1.382 1.457 2.202 3.758 2.202 6.232 0 2.299-.707 4.445-1.926 5.911zm2.795 1.415a.82.82 0 0 1-1.176.096.872.872 0 0 1-.094-1.207c1.276-1.535 2.045-3.87 2.045-6.407 0-2.726-.889-5.22-2.318-6.727a.872.872 0 0 1 .016-1.211.82.82 0 0 1 1.18.016C16.959 6.103 18 9.03 18 12.181c0 2.93-.9 5.66-2.444 7.518z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Nfc.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Nfc as icon };
export default iconHandler(Nfc);